import { render, staticRenderFns } from "./BaseSubmitBlock.vue?vue&type=template&id=ecfdb426&"
import script from "./BaseSubmitBlock.vue?vue&type=script&lang=js&"
export * from "./BaseSubmitBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Server\\domains\\localhost\\ss\\wa-apps\\shop\\plugins\\giftcertificates\\build\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ecfdb426')) {
      api.createRecord('ecfdb426', component.options)
    } else {
      api.reload('ecfdb426', component.options)
    }
    module.hot.accept("./BaseSubmitBlock.vue?vue&type=template&id=ecfdb426&", function () {
      api.rerender('ecfdb426', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/base/BaseSubmitBlock.vue"
export default component.exports